import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ImageAsset as TImageAsset, BlogDetailsPage } from '@/types/generated';
import BlogImageCondition from '../BlogImageCondition';
import { getBlogItemImageStyles } from '../BlogList.styles';
import { featuredBlogBoxStyles, featuredBlogContainerStyles, featuredBlogImageStyles, featuredBlogImageWrapperStyles, featuredButtonStyles, textAndButtonOverlayStyles } from './FeaturedBlog.styles';
import { BlogImage } from '@shared-components/components/BlogDetailsPage';
import TAGLink from '@shared-components/components/TAGLink';
import { useAppContext } from '@shared-components/context/AppContextProvider.ctx';
interface IBlogListItemProps {
  blogDetails: BlogDetailsPage;
}
const FeaturedBlog = ({
  blogDetails
}: IBlogListItemProps) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {
    config
  } = useAppContext();
  const title = blogDetails.title || '';
  const path = blogDetails.path || '';
  const blogRootPath = config.features.blogs.root;
  const blogItemLink = `${blogRootPath}${path}/`;
  const blogImage = blogDetails.blogImage as BlogImage;
  const imageAsset = blogDetails.imageAsset as TImageAsset;
  return <Box width={'100%'} data-testid="featured_blog_container" sx={featuredBlogContainerStyles} data-sentry-element="Box" data-sentry-component="FeaturedBlog" data-sentry-source-file="FeaturedBlog.tsx">
			<TAGLink href={blogItemLink} title={title} linkSx={featuredBlogBoxStyles} dataTestId={`featured_blog_link_${path}`} data-sentry-element="TAGLink" data-sentry-source-file="FeaturedBlog.tsx">
				<Box sx={featuredBlogImageWrapperStyles} data-sentry-element="Box" data-sentry-source-file="FeaturedBlog.tsx">
					<BlogImageCondition imageAsset={imageAsset} blogImage={blogImage} imageAssetStyles={getBlogItemImageStyles} blogImageStyles={featuredBlogImageStyles} dataTestId={imageAsset ? `featured_blog_img_asset_focal_point_image_${path}` : `featured_blog_focal_point_image_${path}`} data-sentry-element="BlogImageCondition" data-sentry-source-file="FeaturedBlog.tsx" />
					{/* Text and Button Overlay */}
					<Box sx={textAndButtonOverlayStyles} data-sentry-element="Box" data-sentry-source-file="FeaturedBlog.tsx">
						<Typography variant={'overline'} color={'text.light'} data-sentry-element="Typography" data-sentry-source-file="FeaturedBlog.tsx">
							{blogDetails.category?.name}
						</Typography>
						<Typography variant={'header1'} color={'text.light'} data-sentry-element="Typography" data-sentry-source-file="FeaturedBlog.tsx">
							{title}
						</Typography>
						<Button size={isMobileScreen ? 'M' : 'S'} variant="secondaryHC" sx={featuredButtonStyles} tabIndex={-1} aria-label={`Learn More about ${title}`} data-sentry-element="Button" data-sentry-source-file="FeaturedBlog.tsx">
							Learn more
						</Button>
					</Box>
				</Box>
			</TAGLink>
		</Box>;
};
export default FeaturedBlog;